import { normalize, schema } from 'normalizr'

const lease = new schema.Entity('leases', {}, { idAttribute: 'lease_id' })
const property = new schema.Entity(
  'properties',
  { leases: [lease] },
  {
    idAttribute: 'property_id',
    processStrategy: value => {
      // We dont have utility function to get country code based on locale.
      // So we are using get/set locale and get country code. Will remove this code and once we have that utility function.
      let newPhoneCC = i18nUtils && i18nUtils.getCountryCode()
      if (
        value.property_locale_code !== i18nUtils &&
        i18nUtils
          .getLocale()
          .split('-')
          .join('_')
      ) {
        const oldLocale = i18nUtils.getLocale()
        i18nUtils.setLocale(value.property_locale_code || i18nUtils.getLocale())
        newPhoneCC = i18nUtils.getCountryCode()
        i18nUtils.setLocale(oldLocale)
      }
      return { ...value, property_locale_country_code: newPhoneCC }
    },
  },
)

export default properties => normalize(properties, [property]).entities
